import { render, staticRenderFns } from "./DefaultNotification.vue?vue&type=template&id=220bdee4&"
import script from "./DefaultNotification.vue?vue&type=script&lang=js&"
export * from "./DefaultNotification.vue?vue&type=script&lang=js&"
import style0 from "./DefaultNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports